import { config } from "@fidget/common/config/config";
import { logger } from "../utils";
import { lazy } from "../utils/lazy";

export class StripeService {
  stripe?: stripe.Stripe;
  stripeApiKey: string;

  constructor(stripeApiKey: string) {
    this.stripeApiKey = stripeApiKey;
  }

  load() {
    return new Promise<void>((resolve, reject) => {
      this.stripe = (window as any).Stripe;
      if (this.stripe) {
        resolve();
      }
      const stripeScript = document.createElement("script");
      stripeScript.src = "https://js.stripe.com/v3/";
      stripeScript.onload = () => {
        this.stripe = (window as any).Stripe(this.stripeApiKey) as stripe.Stripe;
        resolve();
      };
      stripeScript.onerror = () => {
        logger.error("Stripe script not found");
        reject();
      };
      document.head.appendChild(stripeScript);
    });
  }

  redirectToCheckout(
    planId: string,
    quantity: number,
    clientReferenceId: string,
    customerEmail: string
  ) {
    if (this.stripe) {
      const { protocol, hostname } = config.services.spinner;
      const baseUrl = hostname.replace("spinner.", "");
      const successUrl = `${protocol}://${baseUrl}?session_id={CHECKOUT_SESSION_ID}`;
      const cancelUrl = `${protocol}://${baseUrl}`;
      return this.stripe.redirectToCheckout({
        items: [{ plan: planId, quantity }],
        clientReferenceId,
        successUrl,
        cancelUrl,
        customerEmail
      });
    }
    return Promise.reject("stripe is not present");
  }

  redirectToCheckoutWithSessionID(sessionId: string) {
    if (this.stripe) {
      return this.stripe.redirectToCheckout({ sessionId });
    }
    return Promise.reject("stripe is not present");
  }
}

export const stripeService = lazy(() => new StripeService(config.services.stripeApiKey));
